// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","container":"HvC_A","profile":"_2D3Xn"};